import '../../sass/components/_spinner.scss'

function SpinnerMini() {
  return <div className="spinner spinner--mini"></div>
}

export default SpinnerMini
